module.exports = __webpack_public_path__ + "static/icons/icon-map--black-b58bc32016fc019d11052806b4e9da87.svg";